import { _ as _defineProperty } from '../../defineProperty-Y-S4SptN.js';
import { useCallback } from 'react';
import classNames from 'classnames';
import { T as Tooltip } from '../../Tooltip-mQqB3TNx.js';
import { G as GoldIcon } from '../../GoldIcon-Kk2d0NTv.js';
import createUseStyles from '../../create/index.js';
import { FontWeights } from '../../fonts/index.js';
import { j as jsxRuntimeExports } from '../../jsx-runtime-KJzvSKZ_.js';

var useStyles = createUseStyles({
  root: {
    position: 'absolute',
    bottom: 10,
    right: 10,
    fontWeight: FontWeights.Medium
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer'
  },
  largeIcon: {
    width: 30,
    height: 30
  },
  smallIcon: {
    width: 14,
    height: 14,
    '& > img': {
      display: 'block',
      width: 6,
      height: 6
    }
  },
  mediumIcon: {
    width: 19,
    height: 19,
    '& > img': {
      display: 'block',
      width: 10,
      height: 10
    }
  },
  crownIconContainer: {
    position: 'absolute',
    bottom: 10,
    right: 10,
    background: 'rgba(40, 43, 54, 0.8)',
    borderRadius: 50,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  largeCrownIcon: {
    width: 30,
    height: 30
  },
  smallCrownIcon: {
    width: 14,
    height: 14,
    '& > img': {
      display: 'block',
      width: 6,
      height: 6
    }
  },
  mediumCrownIcon: {
    width: 19,
    height: 19,
    '& > img': {
      display: 'block',
      width: 10,
      height: 10
    }
  },
  crownIconTopContainer: {
    top: 15,
    right: 15
  },
  iconSvg: {
    verticalAlign: 'top',
    display: 'inline-block',
    zIndex: function zIndex(props) {
      return props.zIndex;
    },
    '& > svg > path': {
      fill: '#ffffff'
    }
  }
});

function TooltipedCrown(_ref) {
  var className = _ref.className,
    _ref$message = _ref.message,
    message = _ref$message === void 0 ? 'This is premium feature' : _ref$message,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'large' : _ref$size,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'bottom' : _ref$position,
    zIndex = _ref.zIndex,
    dataTest = _ref.dataTest;
  var classes = useStyles({
    zIndex: zIndex
  });
  var handleClickDown = useCallback(function (e) {
    e.stopPropagation();
  }, []);
  return /*#__PURE__*/jsxRuntimeExports.jsx("div", {
    className: classNames(className, classes.root),
    onClick: handleClickDown,
    children: /*#__PURE__*/jsxRuntimeExports.jsx(Tooltip, {
      overlay: message,
      children: /*#__PURE__*/jsxRuntimeExports.jsx("div", {
        "data-test": dataTest,
        className: classNames(classes.iconContainer, _defineProperty({}, classes.crownIconTopContainer, position === 'top')),
        children: /*#__PURE__*/jsxRuntimeExports.jsx(GoldIcon, {
          "aria-label": "Premium",
          className: classNames(classes.iconSvg, classes["".concat(size, "Icon")]),
          "data-test": "crown-icon"
        })
      })
    })
  });
}

export { TooltipedCrown as default };
//# sourceMappingURL=index.js.map
